export type DecisionStatus = "approved" | "dismissed";

export type OperationalRecommendation = {
  id: string;
  priority: "high" | "medium" | "low";
  title: string;
  description: string;
  actionPath: string;
};

export type OperationalDecision = {
  recommendationKey: string;
  decision: DecisionStatus;
};

export function buildDecideTodayRecommendations(
  recommendations: OperationalRecommendation[] = [],
  decisions: OperationalDecision[] = [],
) {
  const decisionsByKey = new Map(decisions.map((item) => [item.recommendationKey, item.decision]));

  return recommendations
    .filter((recommendation) => recommendation.id !== "healthy")
    .filter((recommendation) => decisionsByKey.get(recommendation.id) !== "dismissed")
    .map((recommendation) => ({
      ...recommendation,
      decision: decisionsByKey.get(recommendation.id) ?? null,
    }));
}
